export default __webpack_public_path__ + "e97e6cffd26877b998743f12405a2a4e.jpg";